import styled from "styled-components";

export const StyledCircularLoader = styled.div`
    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
